import React, { useEffect, useState } from "react";
import { Card, Col, ListGroup, Row, Spinner } from "react-bootstrap";

import { useParams } from "react-router-dom";
import CardHeader from "../../components/common/CardHeader";
import { ItemShow } from "../../components/form";
import LinkButton from "../../components/common/LinkButton";
import { privateApi } from "../../api";

const AssociationShow = () => {
      const { associationId } = useParams();
      const [association, setAssociation] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const loadCategories = async () => {
            setLoadingData(true);

            await privateApi
                  .get(`/dashboard/associations/${associationId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setAssociation(response.data.association);
                        }
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadCategories();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Association Details">
                                          <LinkButton
                                                link="/dashboard/associations"
                                                title="Back"
                                          />
                                    </CardHeader>
                                    <Card.Body>
                                          {!loadingData ? (
                                                <Row>
                                                      <Col lg={6}>
                                                            <ListGroup>
                                                                  <ItemShow
                                                                        title="Name"
                                                                        value={
                                                                              association.title
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Category"
                                                                        value={
                                                                              association.category
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="By"
                                                                        value={
                                                                              association.user_name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Date"
                                                                        value={
                                                                              association.date
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Status"
                                                                        value={
                                                                              association.status ===
                                                                              1 ? (
                                                                                    <label className="text-success">
                                                                                          Active
                                                                                    </label>
                                                                              ) : (
                                                                                    <label className="text-danger">
                                                                                          Disabled
                                                                                    </label>
                                                                              )
                                                                        }
                                                                  />
                                                            </ListGroup>
                                                      </Col>
                                                      <Col lg={6}>
                                                            <div className="d-flex p-3 gap-3">
                                                                  {association.image && (
                                                                        <div>
                                                                              <img
                                                                                    style={{
                                                                                          width: "120px",
                                                                                    }}
                                                                                    src={
                                                                                          association.image
                                                                                    }
                                                                                    alt=""
                                                                                    className="rounded"
                                                                              />
                                                                        </div>
                                                                  )}
                                                            </div>
                                                      </Col>
                                                </Row>
                                          ) : (
                                                <>
                                                      <div className="h-25 text-center">
                                                            <Spinner />
                                                      </div>
                                                </>
                                          )}
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default AssociationShow;
